"use client";

import { motion } from "framer-motion";
import { BgLayer, Pulse, Star } from "./bg/BgPrimitives";

export default function InPartnership() {
  return (
    <section id="partnership" className="relative overflow-hidden bg-white py-24 md:py-32 px-4 section-grain">
      <BgLayer>
        <Pulse dur={8}>
          <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%,-50%)", width: "120%", aspectRatio: "1.6", background: "radial-gradient(ellipse, color-mix(in srgb, var(--color-primary) 18%, transparent) 0%, transparent 60%)" }}/>
        </Pulse>
        <div style={{ position: "absolute", left: "10%", right: "10%", bottom: "calc(20% - 20px)", height: 1, background: "linear-gradient(90deg, transparent, var(--color-primary), transparent)", opacity: 0.5 }}/>
        <Star x={12} y={28} size={22} opacity={0.6}/>
        <Star x={86} y={72} size={26} opacity={0.6}/>
      </BgLayer>
      <div className="container mx-auto relative z-10">
        <div className="flex flex-col items-center text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.85 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ type: "spring", stiffness: 240, damping: 20 }}
            className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 md:gap-x-16"
          >
            <img
              src="/fpl-logo.png"
              alt="INJAZ"
              className="m-0 block h-12 md:h-16 lg:h-20 w-auto max-w-[min(100%,240px)] object-contain object-center p-0"
            />
            <span aria-hidden="true" className="hidden md:block h-20 lg:h-24 w-px bg-secondary/15" />
            <img
              src="/images/hsbc/HSBC_RGB.png"
              alt="HSBC"
              className="m-0 block h-20 md:h-28 lg:h-32 w-auto max-w-[min(100%,360px)] object-contain object-center p-0"
            />
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.45, delay: 0.15 }}
            className="text-2xl md:text-3xl font-bold text-foreground mt-8"
          >
            In partnership with
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.45, delay: 0.28 }}
            className="text-muted-foreground max-w-xl mt-3 leading-relaxed"
          >
            This program is delivered with the support of partners who believe in helping youth
            build practical skills for life and work.
          </motion.p>
        </div>
      </div>
    </section>
  );
}
